import { Divider, Grid, Typography } from "@material-ui/core";
import format from "date-fns-tz/format";
import { useEffect, useMemo, useState } from "react";
import { DateWithSlots } from "../../schedule-one-on-one/schedule-one-on-one.constants";
import ToggleSlot from "../../toggle-slot/toggle-slot.component";
import { useStyles } from "./available-time-slots.styles";

interface Props {
  dateWithSlots?: DateWithSlots;
  selected?: string;
  onChange?: (selected: string) => void;
  error?: boolean;
}

export default function AvailableTimeSlots({
  dateWithSlots,
  selected,
  onChange,
  error,
}: Props) {
  const classes = useStyles();

  const [internalSelected, setSelected] = useState<string>(selected);

  useEffect(() => setSelected(selected), [selected]);

  const handleChange = (slot: string) => {
    setSelected(slot);
    onChange?.(slot);
  };

  const timeSlotsWithEmptySlots = useMemo(() => {
    const slots = dateWithSlots?.slots ?? [];
    if (slots.length % 3 !== 0) {
      if (slots.length % 2 === 0) return [...slots, "", ""];
      else return [...slots, ""];
    }
    return slots;
  }, [dateWithSlots]);

  return (
    !!dateWithSlots && (
      <>
        <Divider className={classes.divider} />
        <Grid container className={classes.container}>
          <Grid item container justifyContent="space-between">
            <Typography className={classes.title}>
              Available Time Slots of {format(dateWithSlots.value, "dd MMM")}
            </Typography>
          </Grid>
          <Grid item container className={classes.grid}>
            {error ? (
              <Typography className={classes.error}>
                Unable to schedule your 1:1 because someone just scheduled this
                time slot. Please choose another time slot.
              </Typography>
            ) : !dateWithSlots?.slots?.length ? (
              <Typography className={classes.warning}>
                There are no available time slots for this day. Please choose
                another option.
              </Typography>
            ) : (
              timeSlotsWithEmptySlots.map((slot, i) =>
                slot?.length ? (
                  <ToggleSlot
                    key={slot}
                    isSelected={internalSelected === slot}
                    content={format(new Date(slot), "hh:mma").toLowerCase()}
                    onClick={() => handleChange(slot)}
                  />
                ) : (
                  <Grid key={i} className={classes.emptySlot} />
                )
              )
            )}
          </Grid>
        </Grid>
      </>
    )
  );
}
